import type { Beast, BeastState } from '../../../models/Beast';
import type { Surroundings } from '../../../models/Surroundings';
import type { IBeastState } from './IBeastState';
import { BEAST, DirectionsVectors } from '../../../models/constants';
import { bestDirection } from '../scoring';
import { BeastEatingState } from './BeastEatingState';

export class BeastExploringState implements IBeastState {
    static readonly stateName = 'Beast Exploring';

    get allowInterrupt(): boolean {
        return false;
    }

    canEnter(_beast: Beast, _surroundings: Surroundings): boolean {
        return true;
    }

    tick(beast: Beast, surroundings: Surroundings): BeastState {
        if (beast.directionTicks <= 0) {
            beast.moveDirection = bestDirection(beast, surroundings, false);
            beast.directionTicks = BEAST.DIRECTION_COMMIT_TICKS;
        } else {
            beast.directionTicks--;
        }

        if (beast.moveDirection !== null) {
            const vec = DirectionsVectors.get(beast.moveDirection)!;
            beast.translate(vec.dx * BEAST.EXPLORE_SPEED, vec.dz * BEAST.EXPLORE_SPEED);
        }

        if (beast.health < BEAST.HUNGER_THRESHOLD && surroundings.availableFood > 0) {
            return BeastEatingState.stateName;
        }

        return BeastExploringState.stateName;
    }
}
